// src/config/firebase.config.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAmMYEbnhz9QMrl3f-frDjZl9JrLNOH9zo",
  authDomain: "the-lottery-of-life.firebaseapp.com",
  projectId: "the-lottery-of-life",
  storageBucket: "the-lottery-of-life.firebasestorage.app",
  messagingSenderId: "942413372592",
  appId: "1:942413372592:ios:9737d448b19c98c9a36f75"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 